import { Badge } from '@mantine/core'

export type GmudClassification = 'standard' | 'normal' | 'urgent' | 'emergency'

const CONFIG: Record<GmudClassification, { color: string; label: string; pulse?: boolean }> = {
  standard:  { color: 'green',  label: 'Standard' },
  normal:    { color: 'blue',   label: 'Normal' },
  urgent:    { color: 'orange', label: 'Urgente' },
  emergency: { color: 'red',    label: 'Emergencial', pulse: true },
}

export function GmudClassificationBadge({
  classification, size = 'sm',
}: { classification: GmudClassification | string; size?: 'xs' | 'sm' | 'md' }) {
  const cfg = CONFIG[classification as GmudClassification] ?? { color: 'gray', label: classification }
  return (
    <Badge
      color={cfg.color}
      variant={cfg.pulse ? 'filled' : 'light'}
      size={size}
      style={cfg.pulse ? { animation: 'pulse 2s infinite' } : undefined}
      aria-label={`Classificação: ${cfg.label}`}
    >
      {cfg.label}
    </Badge>
  )
}
